<section class="batch-orders-container">
  <header class="header">
    <div class="title">Batch: {{ batchOrders.name }}</div>
    <div class="numberOf">
      <div class="orderNumberAndPackages">
        No. of orders
        <div class="numberOfValue">{{ batchOrders.orders.length }}</div>
      </div>
    </div>
    <div class="numberOf">
      <div class="orderNumberAndPackages">
        No. of packages
        <div class="numberOfValue">{{ numberOfPackages }}</div>
      </div>
    </div>
    <div role="button" class="close-btn-container" mat-dialog-close>
      <img src="/assets/images/scan/close_icon.svg" alt="" />
    </div>
  </header>
  <mat-divider class="batch-orders-divider"></mat-divider>

  <div class="fulfill-batch">
    <button class="fulfill-batch__btn" [disabled]="isBatchOnFulfillment" (click)="onFulfillBatch(batchOrders.id)">
      @if (isBatchOnFulfillment) {
        <div class="fulfill-batch__spinner">
          <mat-spinner diameter="20" [color]="'#22214C'"></mat-spinner>
        </div>
      } @else {
        Fulfill all orders
      }
    </button>
  </div>
  <div class="batch-orders-content" mat-dialog-content>
    <table class="table" cdk-table [dataSource]="batchOrders.orders">
      <ng-container cdkColumnDef="batchId">
        <th cdk-header-cell *cdkHeaderCellDef></th>
        <td cdk-cell *cdkCellDef="let order">
          @if (checkAbilityToReturnOrder(order, batchOrders)) {
            <app-back-to-assign-btn
              [order]="order"
              [batch]="batchOrders"
              [batchStatus]="batchStatuses[batchOrders.status - 1]"
              (orderMoved)="onOrderMoved($event)"></app-back-to-assign-btn>
          }
        </td>
      </ng-container>

      <ng-container cdkColumnDef="orderNumber">
        <th cdk-header-cell *cdkHeaderCellDef>Order no.</th>
        <td cdk-cell *cdkCellDef="let order">
          {{ order.orderNumber }}
          @if (order.splitted) {
            <span>-{{ ordersSplitIndices[order.id] }}</span>
          }
        </td>
      </ng-container>

      <ng-container cdkColumnDef="itemCount">
        <th cdk-header-cell *cdkHeaderCellDef>Items</th>
        <td cdk-cell *cdkCellDef="let order">
          {{ order.itemCount }}
        </td>
      </ng-container>

      <ng-container cdkColumnDef="shippingId">
        <th cdk-header-cell *cdkHeaderCellDef>Shipping Label</th>
        <td cdk-cell *cdkCellDef="let order">
          {{ order.shippingId || order.deliveryTransaction?.shippingId }}
        </td>
      </ng-container>

      <ng-container cdkColumnDef="lastPrint">
        <th cdk-header-cell *cdkHeaderCellDef>Printing Time</th>
        <td cdk-cell *cdkCellDef="let order">{{ batchOrders.lastPrint | date: 'MMM	dd, hh:mmaaaaa' }}m</td>
      </ng-container>

      <ng-container cdkColumnDef="expectedDate">
        <th cdk-header-cell *cdkHeaderCellDef>Delivery Promise</th>
        <td cdk-cell *cdkCellDef="let order">
          <div
            class="expected-date-cell"
            [ngClass]="{
              today: order.deliveryPromise?.label === 'Today',
              tomorrow: order.deliveryPromise?.label === 'Tomorrow',
              in_x_days: order.deliveryPromise?.label === 'In X Days',
              late_x_days: order.deliveryPromise?.label === 'Late -X Days',
            }">
            <div class="status-indicator"></div>
            <div class="status-text">
              {{ order.deliveryPromise?.print }}
            </div>
            @if (order.deliveryPromise?.default == true) {
              <span class="delivey-date-default">Default</span>
            }
          </div>
        </td>
      </ng-container>

      <ng-container cdkColumnDef="fulfillmentStatus">
        <th cdk-header-cell *cdkHeaderCellDef></th>
        <td class="actions-cell" cdk-cell *cdkCellDef="let order">
          @if (shouldDisplayPreviewButton) {
            <img
              [ngStyle]="{ opacity: !isTplCarrier ? 1 : 0.2 }"
              role="button"
              src="/assets/images/print/eye_icon.svg"
              alt=""
              (click)="previewOrder(order)"
              matTooltipClass="pdq-mat-tooltip"
              [matTooltip]="isTplCarrier ? '' : 'Preview label'" />
          }
          <!-- in the meantime, we keep processing option also for letting wooCommerce shops to fulfill old orders -->
          @if (
            !order.fulfillmentStatus ||
            order.fulfillmentStatus === 'processing' ||
            order.fulfillmentStatus == TranslatedFulfillmentStatus.NOT_FULFILLED
          ) {
            <img
              [ngStyle]="{ opacity: !(isTplCarrier || isBatchOnFulfillment) ? 1 : 0.2 }"
              role="button"
              src="/assets/images/scan/scan_dark_icon.svg"
              alt=""
              disable="{{ !(isTplCarrier || isBatchOnFulfillment) }}"
              (click)="scanOrder(order.id, order.shippingId)"
              [matTooltipClass]="isTplCarrier ? 'table-component__tooltip--above' : 'table-component__tooltip'"
              [matTooltipPosition]="isTplCarrier ? 'above' : 'below'"
              [matTooltip]="isTplCarrier ? 'To be fulfilled by 3PL' : 'Scan order'" />
          }
          @if (order.fulfillmentStatus) {
            <div class="order-fulfilled" [ngClass]="'order-fulfilled__' + order.fulfillmentStatus">
              <img src="/assets/images/scan/fulfill_check_icon.svg" alt="" />
            </div>
          }
          @if (loadingOrder === order.id) {
            <pdq-progress-bar size="small" mode="indeterminate"></pdq-progress-bar>
          }
        </td>
      </ng-container>

      <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
      <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</section>
